import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import {
  AbstractProgressWorkflow,
  Workflow,
  WorkflowStatus,
} from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/entities/ProgressWorkflow/AbstractProgressWorkflow';
import { CreditCardProgressWorkflow } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/CreditCard/_shared/entities/Progress/CreditCardProgressWorkflow';

export class FactoryProgressWorkflow {
  static create(
    status: WorkflowStatus,
    workflow: Workflow,
    paymentMethodType: PaymentMethodType,
  ): AbstractProgressWorkflow {
    if ([PaymentMethodType.CREDIT_CARD].includes(paymentMethodType)) {
      return new CreditCardProgressWorkflow(status, workflow);
    }

    throw new Error('FactoryProgressWorkflow used in wrong PaymentMethodDetailEntity');
  }
}
